module.exports = __webpack_public_path__ + "img/login-gif.86072e1d.gif";